const PopupSearch = (button) => {


    if (typeof button != "undefined" && button != null ) {
        button.addEventListener('click', () => {
            const mobileMenu = document.querySelector('.mobile-menu--active');
            const headerButton = document.querySelector('.header__mobile');
            
            if (typeof mobileMenu != "undefined" && mobileMenu != null && headerButton != "undefined" && headerButton != null) {
                mobileMenu.classList.remove('mobile-menu--active');
                headerButton.classList.remove('active');
            }
        });
    }
}

export default PopupSearch;